export function initVariantSorting() {
    function extractLiters(str) {
        const m = String(str).match(/([\d.,]+)\s*L/i);
        return m ? parseFloat(m[1].replace(',', '.')) : Infinity;
    }

    (function sortCatalog() {
        const catalog = document.getElementById('itemcardVariants');
        if (!catalog) return;
        const wrapper = catalog.querySelector('.itemlist') || catalog;
        const elems = Array.from(wrapper.querySelectorAll('.itemlistElement'));
        elems
            .sort((a, b) => {
                // grab the “x L” part from title or name spans
                let aTxt = a.querySelector('.itemlistElement__media')?.title || '';
                let bTxt = b.querySelector('.itemlistElement__media')?.title || '';
                if (!aTxt) {
                    const as = a.querySelectorAll('.itemlistElement__name span');
                    aTxt = as[as.length - 1]?.textContent || '';
                }
                if (!bTxt) {
                    const bs = b.querySelectorAll('.itemlistElement__name span');
                    bTxt = bs[bs.length - 1]?.textContent || '';
                }
                return extractLiters(aTxt) - extractLiters(bTxt);
            })
            .forEach(el => wrapper.appendChild(el));
    })();

    (function sortItemboxes() {
        document.querySelectorAll('.itemboxList').forEach(list => {
            list.querySelectorAll('.itembox').forEach(box => {
                const bottom = box.querySelector('.itembox__bottom');
                if (!bottom) return;
                const variants = Array.from(bottom.querySelectorAll('.itembox__variant'));
                variants
                    .sort((a, b) =>
                        extractLiters(a.textContent) - extractLiters(b.textContent)
                    )
                    .forEach(v => bottom.appendChild(v));
            });
        });
    })();
}
